module.exports = __webpack_public_path__ + "img/blueprint-red.5eeef430.jpg";